import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "eventId"]

  connect() {
    this.wasOpen = false
    this.observer = new MutationObserver(this.#recordOpening)
    this.observer.observe(this.element, { attributes: true, attributeFilter: ["open"] })
    this.#recordOpening()
  }

  disconnect() {
    this.observer.disconnect()
  }

  #recordOpening = () => {
    if (this.element.ownerDocument.documentElement.hasAttribute("data-turbo-preview")) return

    const isOpen = this.element.open
    if (isOpen && !this.wasOpen) {
      this.eventIdTarget.value = crypto.randomUUID()
      this.formTarget.requestSubmit()
    }
    this.wasOpen = isOpen
  }
}
